module.exports = __webpack_public_path__ + "static/media/3.0f2b7bd1.svg";